export default "__VITE_ASSET__2ab87740__"